var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5603_52365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4733 8.51391L20.29 10.3514V14.8804L23.4474 16.7179C24.2238 17.1578 25.2072 16.6144 25.2072 15.7086V9.52323C25.2331 8.61743 24.2497 8.04807 23.4733 8.51391Z",
    fill: "#373737",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.556 8.12554C18.556 7.47854 18.0384 6.96094 17.3656 6.96094H9.6792L18.5302 15.8119V8.12554H18.556Z",
    fill: "#373737",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.776495 3.6999L4.01149 6.9349H3.1057C2.45869 6.9349 1.94109 7.4525 1.94109 8.0995V17.0799C1.94109 17.7269 2.4587 18.2703 3.13158 18.2703H15.3469L20.8853 23.8087C21.0664 23.9898 21.3511 23.9898 21.5064 23.8087L22.5157 22.7993C22.6969 22.6182 22.6969 22.3335 22.5157 22.1782L2.40694 2.06946C2.25166 1.8883 1.96698 1.8883 1.78582 2.06946L0.776495 3.07878C0.595335 3.25994 0.595335 3.54462 0.776495 3.6999Z",
    fill: "#373737",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5603_52365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.88,
    height: 25.88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/videoOn.412f3027532a1720a1c8657928a2882c.svg";
export { ForwardRef as ReactComponent };